var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionDelete',{attrs:{"disabled":_vm.disabled,"btn-classes":"btn-danger","btn-classes-mobile":"text-danger","show-icons-only":_vm.showIconsOnly},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }